import { useTranslation } from 'react-i18next';

interface ConnectPlatformCardProps {
  name: string;
  description: string;
  color: string;
  icon: string;
  onClick: () => void;
  disabled?: boolean;
  comingSoon?: boolean;
}

export default function ConnectPlatformCard({
  name,
  description,
  color,
  icon,
  onClick,
  disabled = false,
  comingSoon = false,
}: ConnectPlatformCardProps) {
  const { t } = useTranslation();

  return (
    <button
      onClick={onClick}
      disabled={disabled || comingSoon}
      className={`
        border-2 border-black dark:border-gray-700 bg-white dark:bg-gray-950 p-6
        text-left transition-all
        ${!disabled && !comingSoon ? 'hover:bg-gray-50 dark:hover:bg-gray-900 cursor-pointer hover:-translate-y-1' : 'opacity-50 cursor-not-allowed'}
        relative
      `}
    >
      {/* Coming Soon Badge */}
      {comingSoon && (
        <div className="absolute top-2 right-2 bg-yellow-400 text-black text-xs font-bold px-2 py-1 border-2 border-black dark:border-gray-700">
          {t('api.connection.comingSoon')}
        </div>
      )}

      {/* Platform Icon */}
      <div
        className={`${color} text-white w-16 h-16 flex items-center justify-center text-lg font-bold border-2 border-black dark:border-gray-700 mb-4`}
      >
        {icon.toUpperCase()}
      </div>

      {/* Platform Name */}
      <h3 className="text-lg font-bold text-gray-900 dark:text-white mb-2">
        {name}
      </h3>

      {/* Description */}
      <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
        {description}
      </p>

      {/* Connect Button Text */}
      {!comingSoon && (
        <div className="text-sm font-bold text-gray-900 dark:text-white">
          {t('api.connection.connect')} →
        </div>
      )}
    </button>
  );
}
